"use strict";
var __webpack_exports__ = {};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    return o.__proto__ = p, o
  }, _setPrototypeOf(o, p)
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass)
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
    return typeof obj
  } : function _typeof(obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
  }, _typeof(obj)
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self
}

function _possibleConstructorReturn(self, call) {
  if (call && ("object" === _typeof(call) || "function" == typeof call)) return call;
  if (void 0 !== call) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(self)
}

function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o)
  }, _getPrototypeOf(o)
}

function _isNativeFunction(fn) {
  return -1 !== Function.toString.call(fn).indexOf("[native code]")
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
  } catch (e) {
    return !1
  }
}

function _construct(Parent, args, Class) {
  return _construct = _isNativeReflectConstruct() ? Reflect.construct : function _construct(Parent, args, Class) {
    var a = [null];
    a.push.apply(a, args);
    var instance = new(Function.bind.apply(Parent, a));
    return Class && _setPrototypeOf(instance, Class.prototype), instance
  }, _construct.apply(null, arguments)
}

function _wrapNativeSuper(Class) {
  var _cache = "function" == typeof Map ? new Map : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (null === Class || !_isNativeFunction(Class)) return Class;
    if ("function" != typeof Class) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== _cache) {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper)
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor)
    }
    return Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, Class)
  }, _wrapNativeSuper(Class)
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = offcanvas_menu_isNativeReflectConstruct();
  return function _createSuperInternal() {
    var result, Super = _getPrototypeOf(Derived);
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget)
    } else result = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result)
  }
}

function offcanvas_menu_isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
  } catch (e) {
    return !1
  }
}
var OffCanvasMenu = function (_HTMLElement) {
  _inherits(OffCanvasMenu, _wrapNativeSuper(HTMLElement));
  var _super = _createSuper(OffCanvasMenu);

  function OffCanvasMenu() {
    var _this;
    return _classCallCheck(this, OffCanvasMenu), (_this = _super.call(this)).classNames = {
      menuLeft: "offcanvas--left",
      menuPush: "offcanvas--push",
      isOpen: "is-offcanvas-open",
      isPush: "is-offcanvas-push",
      isPushLeft: "is-offcanvas-push-left"
    }, _this.hidden = !0, _this.addDimmer(), _this.initControls(), _this
  }
  return _createClass(OffCanvasMenu, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout((function () {
        _this2.classList.remove("hidden")
      }), 300)
    }
  }, {
    key: "initControls",
    value: function initControls() {
      var _this3 = this;
      this.addEventListener("keyup", (function (evt) {
        return "Escape" === evt.code && _this3.close()
      })), this.closeButtons = this.querySelectorAll('button[name="close"]'), this.closeButtons.forEach((function (b) {
        return b.addEventListener("click", _this3.close.bind(_this3))
      })), this.toggleButtons = document.querySelectorAll('a[href="#'.concat(this.id, '"], [data-menu-toggle="').concat(this.id, '"]')), this.toggleButtons.forEach((function (t) {
        t.addEventListener("click", (function (e) {
          e.preventDefault(), _this3.toggle()
        }))
      }))
    }
  }, {
    key: "open",
    value: function open() {
      var _window$theme, _window$theme$noscrol, _this4 = this,
        openClasses = [this.classNames.isOpen];

      const customMessageIsOpen = document.querySelector('.product-popup-modal[open]') != null;
      if (customMessageIsOpen) return;
      
      this.hidden && (null === (_window$theme = window.theme) || void 0 === _window$theme || null === (_window$theme$noscrol = _window$theme.noscroll) || void 0 === _window$theme$noscrol || _window$theme$noscrol.apply(), this.classList.contains(this.classNames.menuPush) && (openClasses.push(this.classNames.isPush), this.classList.contains(this.classNames.menuLeft) && openClasses.push(this.classNames.isPushLeft)), this.addEventListener("transitionend", (function () {
        _this4.focus(), trapFocus(_this4)
      }), {
        once: !0
      }), this.dimmer.hidden = !1, this.hidden = !1, window.requestAnimationFrame((function () {
        var _document$body$classL;
        _this4.classList.add("is-active"), (_document$body$classL = document.body.classList).add.apply(_document$body$classL, openClasses)
      })))
    }
  }, {
    key: "close",
    value: function close() {
      var _window$theme2, _window$theme2$noscro, _this5 = this;
      this.hidden || (null === (_window$theme2 = window.theme) || void 0 === _window$theme2 || null === (_window$theme2$noscro = _window$theme2.noscroll) || void 0 === _window$theme2$noscro || _window$theme2$noscro.remove(), document.body.classList.remove(this.classNames.isOpen, this.classNames.isPush, this.classNames.isPushLeft), this.addEventListener("transitionend", (function () {
        _this5.hidden = !0, _this5.dimmer.hidden = !0, removeTrapFocus(_this5.activeElement)
      }), {
        once: !0
      }), this.classList.remove("is-active"))
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.hidden ? (this.closeAllMenus(), this.open()) : this.close()
    }
  }, {
    key: "addDimmer",
    value: function addDimmer() {
      this.dimmer = document.querySelector(".offcanvas-dimmer"), this.dimmer || (this.dimmer = document.createElement("div"), this.dimmer.classList.add("offcanvas-dimmer"), document.body.appendChild(this.dimmer), this.dimmer.addEventListener("click", this.closeAllMenus))
    }
  }, {
    key: "closeAllMenus",
    value: function closeAllMenus() {
      document.querySelectorAll("offcanvas-menu").forEach((function (menu) {
        menu.close()
      }))
    }
  }]), OffCanvasMenu
}();
customElements.define("offcanvas-menu", OffCanvasMenu);